const PROGRESS = {
  MOODHEADING: "Most common moods",
  DEMENTIA: "Dementia",
};
export default PROGRESS;
